import { useSyncExternalStore } from "react";
import { AssistantPanel, type HtmlInvocation } from "@traccar/assistant-ui";

function useIsDark() {
    return useSyncExternalStore(
        (cb) => {
            const obs = new MutationObserver(cb);
            obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
            return () => obs.disconnect();
        },
        () => document.documentElement.classList.contains("dark"),
    );
}


export function ChatKitPanel({ onShowHtml, onClearPanel }: {
  onShowHtml: (invocation: HtmlInvocation) => void;
  onClearPanel: () => void;
}) {
  const theme = useIsDark() ? "dark" : "light";
  return (
    <div className="relative flex-1 overflow-hidden bg-background">
      <AssistantPanel
        apiUrl={import.meta.env.VITE_CHATKIT_API_URL ?? "/chatkit"}
        domainKey={import.meta.env.VITE_CHATKIT_API_DOMAIN_KEY ?? "domain_pk_localhost_dev"}
        theme={theme}
        chatTheme={{
          colorScheme: theme,
          typography: {
            fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            baseSize: 14,
          },
          color: {
            grayscale: { hue: 222, tint: 5, shade: theme === "dark" ? 0 : -4 },
            accent: { primary: theme === "dark" ? "#f1f5f9" : "#1e40af", level: 2 },
          },
          radius: "round",
          density: "normal",
        }}
        onShowHtml={onShowHtml}
        onClearPanel={onClearPanel}
      />
    </div>
  );
}
